import styles from './Table.module.css';

export const tableCell = {
  mono: styles.mono,
  num: styles.num,
  nowrap: styles.nowrap,
  actions: styles.actions,
} as const;
